import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  TOOLS_REPORT_GET_EMPLOYEES_LIST: createSagaAction('TOOLS_REPORT_GET_EMPLOYEES_LIST'),
  TOOLS_REPORT_GET_FULL_REPORT: createSagaAction('TOOLS_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  toolsReportGetEmployeesList: ({ filters }) => ({
    type: constants.TOOLS_REPORT_GET_EMPLOYEES_LIST.ACTION,
    filters
  }),
  toolsReportGetFullReport: ({ filters }) => ({
    type: constants.TOOLS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.TOOLS_REPORT_GET_EMPLOYEES_LIST.ACTION:
      return { ...state, error: null, loadingEmployeesList: true }
    case constants.TOOLS_REPORT_GET_EMPLOYEES_LIST.SUCCESS:
      return { ...state, error: null, loadingEmployeesList: false, employeesList: action.payload }

    case constants.TOOLS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.TOOLS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/general/toolsReportActions.js